import PaymentOptions from "../constants/PaymentOptions";
import { deviceTypes } from "../constants/TelcoDeviceTypes";
import { IApplicableBenefit, IOrder, IOrderBasket, IBasketOrderItem, IBasketOrderItems } from "../entities/manhattan/order/types";
import { getLabelsByLanguage } from "./util";
import { ITransaction } from "../entities/checkout/transaction/types";
import { OrderItemsTypes } from "../constants/OrderItemsTypes";

export const getOrderItemByType = (items: IBasketOrderItem[], type: string) : IBasketOrderItem | undefined => {
  return items.find((item: IBasketOrderItem) => item.type === type);
};

export const getOrderItemsByType = (items: IBasketOrderItem[], types: string[]) : IBasketOrderItem[] => {
  return items.filter((item: IBasketOrderItem) => types.indexOf(item.type) > -1);
};

export const getUnavailableProductItems = (items: IBasketOrderItem[], unavailableItemsId: number[]) : IBasketOrderItem[] => {
  return items.filter((item: IBasketOrderItem) => unavailableItemsId.indexOf(item.id) > -1);
};

export const getApplicableBenefitByType = (
  applicableBenefits: IApplicableBenefit[] | undefined,
  name: string
) : IApplicableBenefit | undefined  => {
  return applicableBenefits?.find((item: IApplicableBenefit) => item.type === name);
};

export const isCheckoutSimOnly = (order:IOrder) => {
  const basketItems = getFlatStructureOfBasketItems(order.basket);
  return basketItems.filter((item: IBasketOrderItem) => deviceTypes.includes(item.type)).length <= 0;
};

export const getFlatStructureOfBasketItems = (basket:IOrderBasket) => {
  return basket?.items
    .flatMap((item: IBasketOrderItems) => item.items);
};

export const getAllBasketItems = (basketItems:IBasketOrderItems[]) => {
  return basketItems
    .flatMap((item: IBasketOrderItems) => item.items);
};

export const getOrderItemsByName = (basketItems:IBasketOrderItem[], itemName: string) => {
  return basketItems?.filter((item: IBasketOrderItem) =>
    item.type === itemName
  );
};

export const findTariffPackageForCart = (basket: { items: IBasketOrderItems[] }) => {
  return basket.items
    .map((item: IBasketOrderItems) =>
      item.items.find((innerItem: IBasketOrderItem) => innerItem.type === OrderItemsTypes.TARIFF_PACKAGE)
    )
    .find((foundItem: IBasketOrderItem | undefined) => foundItem !== undefined);
};

export const getOrderItem = (order:IOrder | ITransaction, itemName: string) => {
  const basketItems = getFlatStructureOfBasketItems(order.basket);

  return basketItems?.find((item: IBasketOrderItem) =>
    item.type === itemName
  );
};

export const getMainDeviceComplexCart = (order:IOrder | ITransaction) => {
  const basketItems = getFlatStructureOfBasketItems(order.basket);
  return basketItems.filter((item: IBasketOrderItem) =>  deviceTypes.includes(item.type))[0];
};


export const getPaymentOptionLabel = (label: string) => {
  let paymentOptionLabel = "";
  const labels = getLabelsByLanguage();

  switch (label) {
  case PaymentOptions.ON_DELIVERY:
    paymentOptionLabel = labels.paymentOnDeliveryTelco;
    break;
  case PaymentOptions.ONLINE:
    paymentOptionLabel = labels.paymentOnline;
    break;
  case PaymentOptions.OVER_FIRST_BILL:
    paymentOptionLabel = labels.paymentOverFirstBill;
    break;
  case PaymentOptions.INSTALLMENTS:
    paymentOptionLabel = labels.payInSixInstallments;
    break;
  default:
    break;
  }

  return paymentOptionLabel;
};
